<template>
  <span class="d-inline">
    <cvc-time-input
    label="specific"
      class="mt-2 ml-1"
      v-model="time"
      :min-time="minTime"
      :max-time="'24:00'"
    />
    <cvc-date-input
      class="mt-2"
      v-model="date"
      :allowed-dates="allowedAbsoluteDates"
    /> (that's in {{ relativeDatetime }})
    <span
      v-for="(errorMessage, i) in errorMessages"
      class="red--text"
      :key="`error-message-${i}`"
    >
      {{ errorMessage }}
    </span>
  </span>
</template>

<script>
import CvcDateInput from "@/components/CvcFields/CvcDateInput";
import CvcTimeInput from "@/components/CvcFields/CvcTimeInput";
import { startOfDay, isSameDay, parseISO, addHours, format, formatDistanceToNow } from "date-fns";

export default {
  name: "Calendar",
  components: { CvcDateInput, CvcTimeInput },
  data() {
    return {
      date: "",
      time: "",
    };
  },
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  created() {
    this.date = format(new Date(), "yyyy-MM-dd");
    this.time = format(addHours(new Date(), 1), "HH:mm");
  },
  computed: {
    relativeDatetime() {
      return formatDistanceToNow(this.absoluteDatetime)
    },
    absoluteDatetime() {
      return parseISO(`${this.date}T${this.time}`)
    },
    minTime() {
      return isSameDay(this.absoluteDatetime, new Date())
        ? format(new Date(), "HH:mm")
        : "00:00";
    },
    errorMessages() {
      if (
        isSameDay(this.absoluteDatetime, new Date()) &&
        this.absoluteTime <= new Date()
      ) {
        return ["Please ensure that the message is sent with sufficient time"];
      }
      return [];
    },
    action() {
      return {
        absolute: parseISO(`${this.date}T${this.time}`),
      };
    },
  },
  watch: {
    action: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  },
  methods: {
    allowedAbsoluteDates(val) {
      const absoluteDate = parseISO(val);
      return absoluteDate >= startOfDay(new Date());
    },
  },
};
</script>

<style scoped>
.input-field {
  height: 20px;
  display: inline-block;
}
</style>
